module.exports = __webpack_public_path__ + "img/sword.362bd99c.png";